<!--<div class="card panel-flat">-->
<!--  <div class="panel-heading">-->
<!--    <div class="row">-->

<!--      <div class="col-md-4">-->
<!--        <h5 class="panel-title">CEMS</h5>-->
<!--      </div>-->

<!--      <div class="col-md-8 no-margin">-->
<!--        <div class="col-md-6 row">-->
<!--          <div class="col-md-4 d-flex-row">-->
<!--            <input autocomplete="off" pattern="^[^<>]*$" style="width: 100%;" type="text"-->
<!--                   placeholder="Start Date"-->
<!--                   class="form-control"-->
<!--                   #dp="bsDatepicker"-->
<!--                   bsDatepicker-->

<!--                   [maxDate]="maxStartDate"-->
<!--                   (bsValueChange)="onStartDateChange($event)"/>-->
<!--          </div>-->

<!--          <div class="col-md-4 d-flex-row">-->

<!--            <input autocomplete="off" pattern="^[^<>]*$"  style="width: 100%;" type="text"-->
<!--                   placeholder="End Date"-->
<!--                   class="form-control"-->
<!--                   #dp="bsDatepicker"-->
<!--                   bsDatepicker-->

<!--                   [maxDate]="maxEndDate"-->
<!--                   (bsValueChange)="onEndDateChange($event)"/>-->
<!--          </div>-->
<!--          <div class="col-md-2">-->
<!--            <button class="btn btn-primary" (click)="getAllIndustryDetails()" > <i class="icon icon-search4"></i> Search </button>-->
<!--          </div>-->
<!--        </div>-->
<!--        <ul class="icons-list col-md-6 no-margin-top pull-right">-->
<!--          <li>-->
<!--            <button style="margin-right: 10px; cursor: pointer !important;" type="button" class="btn btn-xs btn-info"><strong>Total Industry </strong>  <span class="badge badge-info">{{allIndustriesDetails.length}}</span></button>-->
<!--          </li>-->

<!--          <li>-->
<!--            <a title="Export Excel." (click)="exportReport('excel')" style="background-color: #EEF3F6; font-weight: 900 !important; color: #000 !important; margin-right: 10px;" class="btn border-primary text-primary btn-flat btn-icon btn-rounded btn-sm">-->
<!--              <i class="icon icon-file-excel"></i>-->
<!--            </a>-->
<!--          </li>-->
<!--          <a id="exportexcelhref" target="_blank"></a>-->

<!--          <li>-->
<!--            <a title="Export PDF." (click)="exportReport('pdf')" style="background-color: #EEF3F6; font-weight: 900 !important; color: #000 !important; margin-right: 10px;" class="btn border-primary text-primary btn-flat btn-icon btn-rounded btn-sm">-->
<!--              <i class="icon icon-file-pdf"></i>-->
<!--            </a>-->
<!--            <a id="exportpdfhref" target="_blank"></a>-->
<!--          </li>-->

<!--          <li>-->
<!--            <select [(ngModel)]="searchField.emmisionType" (change)="getAllIndustryDetails()" class="form-control">-->
<!--              <option value=""> Select Monitoring Type </option>-->
<!--              <option value="air">Air Emission</option>-->
<!--              <option value="water">Water Effluent </option>-->
<!--              <option value="both">Air & Water</option>-->
<!--            </select>-->
<!--          </li>-->
<!--        </ul>-->

<!--      </div>-->

<!--    </div>-->

<!--  </div>-->
<!--  <div class="table-responsive">-->
<!--    <table class="table datatable-show-all">-->
<!--      <thead>-->
<!--      <tr>-->
<!--        <th *ngIf="state == 'Delhi'"  >S.No</th>-->
<!--        <th >Industry Name</th>-->
<!--        <th >Industry ID in OCMMS</th>-->
<!--        <th >Vendor Name</th>-->
<!--        <th >Industry Address</th>-->
<!--        <th >District</th>-->
<!--        <th *ngIf="state != 'Delhi'" >Region</th>-->
<!--        &lt;!&ndash;<th >Sub Region</th>&ndash;&gt;-->
<!--        <th >Category Type</th>-->
<!--        <th >Category of Industry</th>-->
<!--        <th >Parameters</th>-->
<!--        &lt;!&ndash;<th >Name of Category</th>&ndash;&gt;-->
<!--        <th >Initially Connected On</th>-->
<!--        <th >Last Data Received</th>-->
<!--        <th >Connection status</th>-->
<!--        <th  class="text-center">Action</th>-->
<!--      </tr>-->
<!--      <tr>-->
<!--        <th *ngIf="state == 'Delhi'" style=" padding: 4px;"></th>-->
<!--        <th style=" padding: 4px;">-->
<!--          <input autocomplete="off" pattern="^[^<>]*$" [(ngModel)]="searchField.industryName" (keyup)="getAllIndustryDetails()" type="text" class="form-control" placeholder="Search by Name"></th>-->
<!--        <th style=" padding: 4px;">-->
<!--          <input autocomplete="off" pattern="^[^<>]*$" *ngIf="userLevel != 'industry'" [(ngModel)]="searchField.industryId" type="text" class="form-control" (keyup)="getAllIndustryDetails()" placeholder="Search by ID">-->
<!--        </th>-->
<!--        <th style=" padding: 4px;">-->
<!--          &lt;!&ndash;<input *ngIf="userLevel != 'vendor'" [(ngModel)]="searchField.vendorName" type="text" class="form-control" (keyup)="getAllIndustryDetails()" placeholder="Search by Vendor Name">&ndash;&gt;-->

<!--          <input autocomplete="off" pattern="^[^<>]*$" [(ngModel)]="searchField.vendorName" *ngIf="userLevel != 'vendor'" class="form-control" list="vendorList" (keyup)="getAllIndustryDetails()" placeholder="Search by Vendor Name">-->
<!--          <datalist id="vendorList">-->
<!--            <option *ngFor="let vendor of vendorList" value="{{vendor.vendor_short_name}}">-->
<!--          </datalist>-->
<!--        </th>-->
<!--        <th style=" padding: 4px;"><input autocomplete="off" pattern="^[^<>]*$" [(ngModel)]="searchField.address" type="text" class="form-control" (keyup)="getAllIndustryDetails()" placeholder="Search by Address"></th>-->
<!--        <th style=" padding: 4px;">-->
<!--          &lt;!&ndash;<input [(ngModel)]="searchField.district" type="text" class="form-control" (keyup)="getAllIndustryDetails()" placeholder="Search by District">&ndash;&gt;-->
<!--          <select [(ngModel)]="searchField.district" (change)="getAllIndustryDetails()" class="form-control">-->
<!--            <option value=""> Select District </option>-->
<!--            <option value="{{cityRow.city}}" *ngFor="let cityRow of allCityList"> {{cityRow.city}} </option>-->
<!--          </select>-->
<!--        </th>-->
<!--        <th *ngIf="state != 'Delhi'" style=" padding: 4px;">-->
<!--          <select [(ngModel)]="searchField.region" (change)="getAllIndustryDetails()" class="form-control">-->
<!--            <option value=""> Select Region </option>-->
<!--            <option *ngFor="let regionRow of regionList"  value="{{regionRow.region_name}}"> {{regionRow.region_name}} </option>-->
<!--          </select>-->
<!--        </th>-->
<!--        &lt;!&ndash;<th style=" padding: 4px;"><input [(ngModel)]="searchField.subRegion" type="text" class="form-control" (keyup)="getAllIndustryDetails()" placeholder="Search by Name"></th>&ndash;&gt;-->
<!--        <th style=" padding: 4px;">-->
<!--          <input autocomplete="off" pattern="^[^<>]*$" [(ngModel)]="searchField.categoryType" type="text" class="form-control" (keyup)="getAllIndustryDetails()" placeholder="Search by Category Type">-->
<!--        </th>-->

<!--        <th style=" padding: 4px;"><input autocomplete="off" pattern="^[^<>]*$" [(ngModel)]="searchField.indCategory" type="text" class="form-control" (keyup)="getAllIndustryDetails()" placeholder="Search by Industry Category"></th>-->

<!--        <th></th>-->
<!--        &lt;!&ndash;<th>Name of Category</th>&ndash;&gt;-->
<!--        <th style=" padding: 4px;">-->
<!--          <input autocomplete="off" pattern="^[^<>]*$" style="width: 100%;" type="text"-->
<!--                 placeholder="Initial Connected Date"-->
<!--                 class="form-control"-->
<!--                 #dp="bsDatepicker"-->
<!--                 bsDatepicker-->

<!--                 [maxDate]="maxIniConnectedDate"-->
<!--                 (bsValueChange)="onIniConnectedDateChange($event)"/>-->
<!--        </th>-->
<!--        <th style=" padding: 4px;">-->
<!--          <input autocomplete="off" pattern="^[^<>]*$" style="width: 100%;" type="text"-->
<!--                 placeholder="Last Data Received"-->
<!--                 class="form-control"-->
<!--                 #dp="bsDatepicker"-->
<!--                 bsDatepicker-->

<!--                 [maxDate]="maxLastUpdateDate"-->
<!--                 (bsValueChange)="onMaxLastUpdateDateChange($event)"/>-->
<!--        </th>-->
<!--        <th style=" padding: 4px;">-->
<!--          &lt;!&ndash;<input  type="text" class="form-control"  placeholder="Search by Status">&ndash;&gt;-->
<!--          <select [(ngModel)]="searchField.status" (change)="getAllIndustryDetails()" class="form-control">-->
<!--            <option value=""> Select Status </option>-->
<!--            <option value="online"> Online </option>-->
<!--            <option value="offline"> Offline </option>-->
<!--            <option value="delay"> Delay </option>-->
<!--            &lt;!&ndash;<option value="under maintenance"> Under Maintenance </option>&ndash;&gt;-->
<!--            &lt;!&ndash;<option value="closed"> Closed by CPCB/HSPCB </option>&ndash;&gt;-->
<!--          </select>-->
<!--        </th>-->
<!--        <th style=" padding: 4px;" class="text-center"></th>-->
<!--      </tr>-->
<!--      </thead>-->

<!--      <tbody *ngIf="!industryListLoader &&  allIndustriesDetails.length">-->
<!--      <tr *ngFor="let industry of allIndustriesDetails let i = index" [attr.data-index]="i">-->
<!--        <td *ngIf="state == 'Delhi'"> {{i + 1}} </td>-->
<!--        <td style="text-transform: capitalize;" title="{{industry.name}}"><a [routerLink]="['/industry']" [queryParams]="{industry_id: industry.id | base64:'encode'}">-->
<!--          {{(industry.name.length>40)? (industry.name | slice:0:40)+'...':(industry.name)}}-->
<!--        </a></td>-->
<!--        <td title="{{industry.hr_ocmms_id}}">-->
<!--          <span *ngIf="industry.hr_ocmms_id">{{ (industry.hr_ocmms_id.length>10)? ((industry.hr_ocmms_id | slice:0:10)+'...'):(industry.hr_ocmms_id) }}</span>-->
<!--          <span *ngIf="!industry.hr_ocmms_id">{{industry.hr_ocmms_id}}</span>-->
<!--          &lt;!&ndash;{{industry.hr_ocmms_id}}&ndash;&gt;-->
<!--        </td>-->
<!--        <td title="{{industry.vendors}}" style="text-transform: capitalize;">-->
<!--          {{ (industry.vendors && (industry.vendors.length>10))? ((industry.vendors | slice:0:10)+'...'):(industry.vendors) }}-->
<!--        </td>-->
<!--        <td  style="word-break: break-all; " title="{{industry.address}}">{{(industry.address.length>50)? (industry.address | slice:0:50)+'...':(industry.address)}}</td>-->

<!--        <td style="word-break: break-all;">{{industry.city}}</td>-->
<!--        <td *ngIf="state != 'Delhi'" style="word-break: break-all;">-->
<!--          {{industry.region_name}}-->
<!--        </td>-->

<!--        <td style="word-break: break-all;">{{industry.industry_category}}</td>-->
<!--        <td title="{{industry.industry_type}}" style="word-break: break-all;">-->
<!--          {{ (industry.industry_type.length>10)? ((industry.industry_type | slice:0:10)+'...'):(industry.industry_type) }}-->
<!--        </td>-->

<!--        &lt;!&ndash;          <td>&ndash;&gt;-->
<!--        &lt;!&ndash;                <span class="label label-primary" style="text-transform:none !important;margin-left: 2px; margin-right: 2px; margin-top: 2px; margin-bottom: 2px;" *ngFor="let parameter of industry.parameter | parameterSplit | keyvalue">&ndash;&gt;-->
<!--        &lt;!&ndash;                  {{ (parameter.value && parameter.value.toLowerCase() == 'ph' ? 'pH' : parameter.value.toUpperCase()) }}&ndash;&gt;-->
<!--        &lt;!&ndash;                </span>&ndash;&gt;-->
<!--        &lt;!&ndash;          </td>&ndash;&gt;-->

<!--        <td>-->
<!--                <span class="label label-primary" [ngStyle]="{ 'background-color': parameter.color, 'border-color': parameter.color, 'text-decoration': parameter.color=== '#ffad00' ? 'line-through': '',  'color': parameter.color=== '#ffad00' ? '#1d1d1d': '#ffffff',  'text-decoration-color': parameter.color=== '#ffad00' ? '#1d1d1d': '#ffffff'     }" style="margin-left: 2px; margin-right: 2px; margin-top: 2px; margin-bottom: 2px;" *ngFor="let parameter of industry.parameter_values">-->
<!--                  {{ (parameter.name && parameter.name.toLowerCase() == 'ph' ? 'pH' : parameter.name.toUpperCase()) }}-->
<!--                </span>-->
<!--        </td>-->

<!--        <td>-->
<!--          <div style="margin-bottom: 5px;" class="label label-primary">{{industry.created_date | date: 'dd/MM/yyyy' }}</div>-->
<!--          <div class="label label-primary">{{industry.created_date | date: 'H:mm' }}</div>-->
<!--        </td>-->

<!--        <td>-->
<!--          <div style="margin-bottom: 5px;" class="label label-primary">{{industry.last_update_date | date: 'dd/MM/yyyy' }}</div>-->
<!--          <div class="label label-primary">{{industry.last_update_date?(industry.last_update_date | date: 'H:mm'):'No Data' }}</div>-->
<!--        </td>-->
<!--        <td>-->
<!--          <span *ngIf="(industry.last_update_date | industryStatus) == 'Delay'" class="label label-warning">{{industry.last_update_date | industryStatus}}</span>-->
<!--          <span *ngIf="(industry.last_update_date | industryStatus) == 'Online'" class="label label-success"><strong>{{industry.last_update_date | industryStatus}}</strong></span>-->
<!--          <span *ngIf="(industry.last_update_date | industryStatus) == 'Offline'" class="label label-danger">{{industry.last_update_date | industryStatus}}</span>-->
<!--        </td>-->

<!--        <td class="text-center">-->
<!--          &lt;!&ndash;<td class="text-center">&ndash;&gt;-->
<!--          <ul class="icons-list">-->
<!--&lt;!&ndash;            <li class="dropdown">&ndash;&gt;-->
<!--&lt;!&ndash;              <a class="dropdown-toggle" data-toggle="dropdown">&ndash;&gt;-->
<!--&lt;!&ndash;                <i class="icon-menu9"></i>&ndash;&gt;-->
<!--&lt;!&ndash;              </a>&ndash;&gt;-->

<!--&lt;!&ndash;              <ul class="dropdown-menu dropdown-menu-right">&ndash;&gt;-->
<!--&lt;!&ndash;                <li title="View Industry Analytics" style="cursor: not-allowed;"><a [routerLink]="['/industry']" [queryParams]="{industry_id: industry.id | base64:'encode'}"><i class="icon icon-graph"></i> View Analytics</a></li>&ndash;&gt;-->
<!--&lt;!&ndash;                <li title="View Industry Information" style="cursor: not-allowed;"><a [routerLink]="['/industry-edit']" [queryParams]="{industry_id: industry.id | base64:'encode', type: 'view' | base64:'encode'}"><i class="icon icon-eye4"></i> View Info.</a></li>&ndash;&gt;-->
<!--&lt;!&ndash;                <li *ngIf="userLevel == 'admin' || userName == 'HSPCBCEMS' || production == false" title="Update Industry Details" style="cursor: not-allowed;"><a [routerLink]="['/industry-edit']" [queryParams]="{industry_id: industry.id | base64:'encode',type: 'edit' | base64:'encode'}"><i class="icon icon-loop3"></i> Update Details</a></li>&ndash;&gt;-->
<!--&lt;!&ndash;                <li *ngIf="userLevel == 'admin' || userName == 'HSPCBCEMS'  || production == false" title="Delete Industry"><a (click)="deleteIndustry(industry.id)"><i class="icon icon-bin"></i> Delete</a></li>&ndash;&gt;-->
<!--&lt;!&ndash;                <li *ngIf="userLevel == 'admin' || userName == 'HSPCBCEMS'  || production == false" title="Archive Industry"><a (click)="archiveIndustry(industry.id)"><i class="fa fa-archive"></i> Archive</a></li>&ndash;&gt;-->

<!--&lt;!&ndash;                &lt;!&ndash;<li title="Update Industry Details" style="cursor: not-allowed;"><a [routerLink]="['/industry-edit']" [queryParams]="{industry_id: industry.id | base64:'encode',type: 'edit' | base64:'encode'}"><i class="icon icon-loop3"></i> Update Details</a></li>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;                &lt;!&ndash;<li title="Delete Industry"><a (click)="deleteIndustry(industry.id)"><i class="icon icon-bin"></i> Delete</a></li>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;              </ul>&ndash;&gt;-->
<!--&lt;!&ndash;            </li>&ndash;&gt;-->
<!--            <li class="dropdown">-->
<!--              <a class="dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">-->
<!--                <i class="icon-menu9"></i>-->
<!--              </a>-->
<!--              <ul class="dropdown-menu dropdown-menu-end">-->
<!--                <li title="View Industry Analytics">-->
<!--                  <a class="dropdown-item" [routerLink]="['/industry']" [queryParams]="{industry_id: industry.id | base64:'encode'}">-->
<!--                    <i class="icon icon-graph"></i> View Analytics-->
<!--                  </a>-->
<!--                </li>-->
<!--                <li title="View Industry Information">-->
<!--                  <a class="dropdown-item" [routerLink]="['/industry-edit']" [queryParams]="{industry_id: industry.id | base64:'encode', type: 'view' | base64:'encode'}">-->
<!--                    <i class="icon icon-eye4"></i> View Info.-->
<!--                  </a>-->
<!--                </li>-->
<!--                <li *ngIf="userLevel == 'admin' || userName == 'HSPCBCEMS' || production == false" title="Update Industry Details">-->
<!--                  <a class="dropdown-item" [routerLink]="['/industry-edit']" [queryParams]="{industry_id: industry.id | base64:'encode', type: 'edit' | base64:'encode'}">-->
<!--                    <i class="icon icon-loop3"></i> Update Details-->
<!--                  </a>-->
<!--                </li>-->
<!--                <li *ngIf="userLevel == 'admin' || userName == 'HSPCBCEMS' || production == false" title="Delete Industry">-->
<!--                  <a class="dropdown-item" (click)="deleteIndustry(industry.id)">-->
<!--                    <i class="icon icon-bin"></i> Delete-->
<!--                  </a>-->
<!--                </li>-->
<!--                <li *ngIf="userLevel == 'admin' || userName == 'HSPCBCEMS' || production == false" title="Archive Industry">-->
<!--                  <a class="dropdown-item" (click)="archiveIndustry(industry.id)">-->
<!--                    <i class="fa fa-archive"></i> Archive-->
<!--                  </a>-->
<!--                </li>-->
<!--              </ul>-->
<!--            </li>-->

<!--          </ul>-->
<!--        </td>-->
<!--        &lt;!&ndash;<td class="text-center">&ndash;&gt;-->
<!--        &lt;!&ndash;<button class="btn btn-xs" style="padding: 5px; padding-left: 10px; padding-right: 10px; background-color: #38B2F7;" title="More detail">&ndash;&gt;-->
<!--        &lt;!&ndash;<a style="color: #fff;" [routerLink]="['/industry']" [queryParams]="{industry_id: industry.id}"><i class="icon-more2"></i></a>&ndash;&gt;-->
<!--        &lt;!&ndash;</button>&ndash;&gt;-->
<!--        &lt;!&ndash;</td>&ndash;&gt;-->
<!--      </tr>-->
<!--      </tbody>-->

<!--      <tbody *ngIf="!industryListLoader && !allIndustriesDetails.length" >-->
<!--      <tr>-->
<!--        <td colspan="12" class="col-lg-12 text-center" style="height: 180px;">-->
<!--          <div class="label label-danger" style="margin-top: 50px;">No Industry Found</div>-->
<!--        </td>-->
<!--      </tr>-->
<!--      </tbody>-->

<!--      <tbody *ngIf="industryListLoader" >-->
<!--      <tr>-->
<!--        <td colspan="12" class="col-lg-12 text-center" style="height: 180px;">-->
<!--          <div style="margin-top: 50px;">-->
<!--            <img src="/assets/images/load.gif" />-->
<!--          </div>-->
<!--        </td>-->
<!--      </tr>-->
<!--      </tbody>-->

<!--    </table>-->
<!--  </div>-->
<!--</div>-->

<div class="card panel-flat">
  <div class="card panel-flat">
    <div class="card-header panel-heading">
      <div class="row align-items-center gx-2">

        <div class="col-md-2">
          <h5 class="panel-title mb-0">CEMS</h5>
        </div>

        <div class="col-md-10 d-flex align-items-center justify-content-end flex-wrap no-margin">

          <div class="d-flex flex-wrap align-items-center me-3">
            <div class="me-2">
              <input autocomplete="off" pattern="^[^<>]*$" type="text"
                     placeholder="Start Date"
                     class="form-control"
                     style="width: 100%; min-width: 150px;"
                     #dp="bsDatepicker"
                     bsDatepicker
                     [maxDate]="maxStartDate"
                     (bsValueChange)="onStartDateChange($event)"/>
            </div>

            <div class="me-2">
              <input autocomplete="off" pattern="^[^<>]*$" type="text"
                     placeholder="End Date"
                     class="form-control"
                     style="width: 100%; min-width: 150px;"
                     #dp="bsDatepicker"
                     bsDatepicker
                     [maxDate]="maxEndDate"
                     (bsValueChange)="onEndDateChange($event)"/>
            </div>

            <div class="me-3">
              <button class="btn btn-primary" (click)="getAllIndustryDetails()">
                <i class="icon icon-search4"></i> Search
              </button>
            </div>
          </div>

          <div class="d-flex flex-wrap align-items-center me-3">
            <button style="margin-right: 10px; cursor: pointer !important;"
                    type="button"
                    class="btn btn-xs btn-info d-flex align-items-center text-white">
              <strong>Total Industry</strong>
              <span class="badge ms-2"
                    style="background-color: white; color: var(--bs-info);">
      {{ allIndustriesDetails.length }}
    </span>
            </button>
          </div>

          <div class="d-flex align-items-center me-2">
            <a title="Export Excel."
               (click)="exportReport('excel')"
               style="background-color: #EEF3F6; font-weight: 900 !important; color: #000 !important; margin-right: 10px;"
               class="btn border-primary text-primary btn-flat btn-icon btn-rounded btn-sm">
              <i class="icon icon-file-excel"></i>
            </a>
            <a id="exportexcelhref" target="_blank"></a>
          </div>

          <div class="d-flex align-items-center me-2">
            <a title="Export PDF."
               (click)="exportReport('pdf')"
               style="background-color: #EEF3F6; font-weight: 900 !important; color: #000 !important; margin-right: 10px;"
               class="btn border-primary text-primary btn-flat btn-icon btn-rounded btn-sm">
              <i class="icon icon-file-pdf"></i>
            </a>
            <a id="exportpdfhref" target="_blank"></a>
          </div>

          <div style="min-width: 200px;">
            <select [(ngModel)]="searchField.emmisionType"
                    (change)="getAllIndustryDetails()"
                    class="form-control">
              <option value=""> Select Monitoring Type </option>
              <option value="air">Air Emission</option>
              <option value="water">Water Effluent </option>
              <option value="both">Air & Water</option>
            </select>
          </div>

        </div>
      </div>
    </div>
  </div>
<div class="p-3">
  <div>
    Color of parameter values is solely based on last parameter values received
  </div>

  <div class="mt-2 d-flex gap-3 flex-wrap align-items-center">
    <div class="d-flex align-items-center gap-2">
      <div class="rounded-1" style="width: 15px; height: 15px; background-color: #ff0000;"></div>
      <span class="fs-6">Parameter exceeded</span>
    </div>

    <div class="d-flex align-items-center gap-2">
      <div class="rounded-1" style="width: 15px; height: 15px; background-color: #008000;"></div>
      <span class="fs-6">Within limits</span>
    </div>

    <div class="d-flex align-items-center gap-2">
      <div class="rounded-1" style="width: 15px; height: 15px; background-color: #ffad00;"></div>
      <span class="fs-6">No last data received</span>
    </div>

    <div class="d-flex align-items-center gap-2">
      <div class="rounded-1" style="width: 15px; height: 15px; background-color: #9c9c9c;"></div>
      <span class="fs-6">Min/Max not saved</span>
    </div>
  </div>
</div>

  <div class="table-responsive">
    <table class="table datatable-show-all">
      <thead>
      <tr>
        <th *ngIf="state == 'Delhi'"  >S.No</th>
        <th >Industry Name</th>
        <th >Industry ID in OCMMS</th>
        <th >Vendor Name</th>
        <th >Industry Address</th>
        <th >District</th>
        <th *ngIf="state != 'Delhi'" >Region</th>
        <!--<th >Sub Region</th>-->
        <th >Category Type</th>
        <th >Category of Industry</th>
        <th >Parameters</th>
        <!--<th >Name of Category</th>-->
        <th >Initially Connected On</th>
        <th >Last Data Received</th>
        <th >Connection status</th>
        <th  class="text-center">Action</th>
      </tr>
      <tr>
        <th *ngIf="state == 'Delhi'" style=" padding: 4px;"></th>
        <th style=" padding: 4px;">
          <input autocomplete="off" pattern="^[^<>]*$" [(ngModel)]="searchField.industryName" (keyup)="getAllIndustryDetails()" type="text" class="form-control" placeholder="Search by Name"></th>
        <th style=" padding: 4px;">
          <input autocomplete="off" pattern="^[^<>]*$" *ngIf="userLevel != 'industry'" [(ngModel)]="searchField.industryId" type="text" class="form-control" (keyup)="getAllIndustryDetails()" placeholder="Search by ID">
        </th>
        <th style=" padding: 4px;">
          <!--<input *ngIf="userLevel != 'vendor'" [(ngModel)]="searchField.vendorName" type="text" class="form-control" (keyup)="getAllIndustryDetails()" placeholder="Search by Vendor Name">-->

          <input autocomplete="off" pattern="^[^<>]*$" [(ngModel)]="searchField.vendorName" *ngIf="userLevel != 'vendor'" class="form-control" list="vendorList" (keyup)="getAllIndustryDetails()" placeholder="Search by Vendor Name">
          <datalist id="vendorList">
            <option *ngFor="let vendor of vendorList" value="{{vendor.vendor_short_name}}">
          </datalist>
        </th>
        <th style=" padding: 4px;"><input autocomplete="off" pattern="^[^<>]*$" [(ngModel)]="searchField.address" type="text" class="form-control" (keyup)="getAllIndustryDetails()" placeholder="Search by Address"></th>
        <th style=" padding: 4px;">
          <!--<input [(ngModel)]="searchField.district" type="text" class="form-control" (keyup)="getAllIndustryDetails()" placeholder="Search by District">-->
          <select [(ngModel)]="searchField.district" (change)="getAllIndustryDetails()" class="form-control">
            <option value=""> Select District </option>
            <option value="{{cityRow.city}}" *ngFor="let cityRow of allCityList"> {{cityRow.city}} </option>
          </select>
        </th>
        <th *ngIf="state != 'Delhi'" style=" padding: 4px;">
          <select [(ngModel)]="searchField.region" (change)="getAllIndustryDetails()" class="form-control">
            <option value=""> Select Region </option>
            <option *ngFor="let regionRow of regionList"  value="{{regionRow.region_name}}"> {{regionRow.region_name}} </option>
          </select>
        </th>
        <!--<th style=" padding: 4px;"><input [(ngModel)]="searchField.subRegion" type="text" class="form-control" (keyup)="getAllIndustryDetails()" placeholder="Search by Name"></th>-->
        <th style=" padding: 4px;">
          <input autocomplete="off" pattern="^[^<>]*$" [(ngModel)]="searchField.categoryType" type="text" class="form-control" (keyup)="getAllIndustryDetails()" placeholder="Search by Category Type">
        </th>

        <th style=" padding: 4px;"><input autocomplete="off" pattern="^[^<>]*$" [(ngModel)]="searchField.indCategory" type="text" class="form-control" (keyup)="getAllIndustryDetails()" placeholder="Search by Industry Category"></th>

        <th></th>
        <!--<th>Name of Category</th>-->
        <th style=" padding: 4px;">
          <input autocomplete="off" pattern="^[^<>]*$" style="width: 100%;" type="text"
                 placeholder="Initial Connected Date"
                 class="form-control"
                 #dp="bsDatepicker"
                 bsDatepicker

                 [maxDate]="maxIniConnectedDate"
                 (bsValueChange)="onIniConnectedDateChange($event)"/>
        </th>
        <th style=" padding: 4px;">
          <input autocomplete="off" pattern="^[^<>]*$" style="width: 100%;" type="text"
                 placeholder="Last Data Received"
                 class="form-control"
                 #dp="bsDatepicker"
                 bsDatepicker

                 [maxDate]="maxLastUpdateDate"
                 (bsValueChange)="onMaxLastUpdateDateChange($event)"/>
        </th>
        <th style=" padding: 4px;">
          <!--<input  type="text" class="form-control"  placeholder="Search by Status">-->
          <select [(ngModel)]="searchField.status" (change)="getAllIndustryDetails()" class="form-control">
            <option value=""> Select Status </option>
            <option value="online"> Online </option>
            <option value="offline"> Offline </option>
            <option value="delay"> Delay </option>
            <!--<option value="under maintenance"> Under Maintenance </option>-->
            <!--<option value="closed"> Closed by CPCB/HSPCB </option>-->
          </select>
        </th>
        <th style=" padding: 4px;" class="text-center"></th>
      </tr>
      </thead>

      <tbody *ngIf="!industryListLoader &&  allIndustriesDetails.length">
      <tr *ngFor="let industry of allIndustriesDetails let i = index" [attr.data-index]="i">
        <td *ngIf="state == 'Delhi'"> {{i + 1}} </td>
        <td style="text-transform: capitalize;" title="{{industry.name}}"><a [routerLink]="['/industry']" [queryParams]="{industry_id: industry.id | base64:'encode'}">
          {{(industry.name.length>40)? (industry.name | slice:0:40)+'...':(industry.name)}}
        </a></td>
        <td title="{{industry.hr_ocmms_id}}">
          <span *ngIf="industry.hr_ocmms_id">{{ (industry.hr_ocmms_id.length>10)? ((industry.hr_ocmms_id | slice:0:10)+'...'):(industry.hr_ocmms_id) }}</span>
          <span *ngIf="!industry.hr_ocmms_id">{{industry.hr_ocmms_id}}</span>
          <!--{{industry.hr_ocmms_id}}-->
        </td>
        <td title="{{industry.vendors}}" style="text-transform: capitalize;">
          {{ (industry.vendors && (industry.vendors.length>10))? ((industry.vendors | slice:0:10)+'...'):(industry.vendors) }}
        </td>
        <td  style="word-break: break-all; " title="{{industry.address}}">{{(industry.address.length>50)? (industry.address | slice:0:50)+'...':(industry.address)}}</td>

        <td style="word-break: break-all;">{{industry.city}}</td>
        <td *ngIf="state != 'Delhi'" style="word-break: break-all;">
          {{industry.region_name}}
        </td>

        <td style="word-break: break-all;">{{industry.industry_category}}</td>
        <td title="{{industry.industry_type}}" style="word-break: break-all;">
          {{ (industry.industry_type.length>10)? ((industry.industry_type | slice:0:10)+'...'):(industry.industry_type) }}
        </td>

        <!--          <td>-->
        <!--                <span class="label label-primary" style="text-transform:none !important;margin-left: 2px; margin-right: 2px; margin-top: 2px; margin-bottom: 2px;" *ngFor="let parameter of industry.parameter | parameterSplit | keyvalue">-->
        <!--                  {{ (parameter.value && parameter.value.toLowerCase() == 'ph' ? 'pH' : parameter.value.toUpperCase()) }}-->
        <!--                </span>-->
        <!--          </td>-->

        <td>
                <span class="label label-primary" [ngStyle]="{ 'background-color': parameter.color, 'border-color': parameter.color, 'text-decoration': parameter.color=== '#ffad00' ? 'line-through': '',  'color': parameter.color=== '#ffad00' ? '#1d1d1d': '#ffffff',  'text-decoration-color': parameter.color=== '#ffad00' ? '#1d1d1d': '#ffffff'     }" style="margin-left: 2px; margin-right: 2px; margin-top: 2px; margin-bottom: 2px;" *ngFor="let parameter of industry.parameter_values">
                  {{ (parameter.name && parameter.name.toLowerCase() == 'ph' ? 'pH' : parameter.name.toUpperCase()) }}
                </span>
        </td>

        <td>
          <div style="margin-bottom: 5px;" class="label label-primary">{{industry.created_date | date: 'dd/MM/yyyy' }}</div>
          <div class="label label-primary">{{industry.created_date | date: 'H:mm' }}</div>
        </td>

        <td>
          <div style="margin-bottom: 5px;" class="label label-primary">{{industry.last_update_date | date: 'dd/MM/yyyy' }}</div>
          <div class="label label-primary">{{industry.last_update_date?(industry.last_update_date | date: 'H:mm'):'No Data' }}</div>
        </td>
        <td>
          <span *ngIf="(industry.last_update_date | industryStatus) == 'Delay'" class="label label-warning">{{industry.last_update_date | industryStatus}}</span>
          <span *ngIf="(industry.last_update_date | industryStatus) == 'Online'" class="label label-success"><strong>{{industry.last_update_date | industryStatus}}</strong></span>
          <span *ngIf="(industry.last_update_date | industryStatus) == 'Offline'" class="label label-danger">{{industry.last_update_date | industryStatus}}</span>
        </td>

        <td class="text-center">
          <!--<td class="text-center">-->
          <ul class="icons-list">
            <!--            <li class="dropdown">-->
            <!--              <a class="dropdown-toggle" data-toggle="dropdown">-->
            <!--                <i class="icon-menu9"></i>-->
            <!--              </a>-->

            <!--              <ul class="dropdown-menu dropdown-menu-right">-->
            <!--                <li title="View Industry Analytics" style="cursor: not-allowed;"><a [routerLink]="['/industry']" [queryParams]="{industry_id: industry.id | base64:'encode'}"><i class="icon icon-graph"></i> View Analytics</a></li>-->
            <!--                <li title="View Industry Information" style="cursor: not-allowed;"><a [routerLink]="['/industry-edit']" [queryParams]="{industry_id: industry.id | base64:'encode', type: 'view' | base64:'encode'}"><i class="icon icon-eye4"></i> View Info.</a></li>-->
            <!--                <li *ngIf="userLevel == 'admin' || userName == 'HSPCBCEMS' || production == false" title="Update Industry Details" style="cursor: not-allowed;"><a [routerLink]="['/industry-edit']" [queryParams]="{industry_id: industry.id | base64:'encode',type: 'edit' | base64:'encode'}"><i class="icon icon-loop3"></i> Update Details</a></li>-->
            <!--                <li *ngIf="userLevel == 'admin' || userName == 'HSPCBCEMS'  || production == false" title="Delete Industry"><a (click)="deleteIndustry(industry.id)"><i class="icon icon-bin"></i> Delete</a></li>-->
            <!--                <li *ngIf="userLevel == 'admin' || userName == 'HSPCBCEMS'  || production == false" title="Archive Industry"><a (click)="archiveIndustry(industry.id)"><i class="fa fa-archive"></i> Archive</a></li>-->

            <!--                &lt;!&ndash;<li title="Update Industry Details" style="cursor: not-allowed;"><a [routerLink]="['/industry-edit']" [queryParams]="{industry_id: industry.id | base64:'encode',type: 'edit' | base64:'encode'}"><i class="icon icon-loop3"></i> Update Details</a></li>&ndash;&gt;-->
            <!--                &lt;!&ndash;<li title="Delete Industry"><a (click)="deleteIndustry(industry.id)"><i class="icon icon-bin"></i> Delete</a></li>&ndash;&gt;-->
            <!--              </ul>-->
            <!--            </li>-->
            <li class="dropdown">
              <a  href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                <i class="icon-menu9"></i>
              </a>
              <ul class="dropdown-menu dropdown-menu-end">
                <li title="View Industry Analytics">
                  <a class="dropdown-item" [routerLink]="['/industry']" [queryParams]="{industry_id: industry.id | base64:'encode'}">
                    <i class="icon icon-graph"></i> View Analytics
                  </a>
                </li>
                <li title="View Industry Information">
                  <a class="dropdown-item" [routerLink]="['/industry-edit']" [queryParams]="{industry_id: industry.id | base64:'encode', type: 'view' | base64:'encode'}">
                    <i class="icon icon-eye4"></i> View Info.
                  </a>
                </li>
                <li *ngIf="userLevel == 'admin' || userName == 'HSPCBCEMS' || production == false" title="Update Industry Details">
                  <a class="dropdown-item" [routerLink]="['/industry-edit']" [queryParams]="{industry_id: industry.id | base64:'encode', type: 'edit' | base64:'encode'}">
                    <i class="icon icon-loop3"></i> Update Details
                  </a>
                </li>
                <li *ngIf="userLevel == 'admin' || userName == 'HSPCBCEMS' || production == false" title="Delete Industry">
                  <a class="dropdown-item" (click)="deleteIndustry(industry.id)">
                    <i class="icon icon-bin"></i> Delete
                  </a>
                </li>
                <li *ngIf="userLevel == 'admin' || userName == 'HSPCBCEMS' || production == false" title="Archive Industry">
                  <a class="dropdown-item" (click)="archiveIndustry(industry.id)">
                    <i class="fa fa-archive"></i> Archive
                  </a>
                </li>
              </ul>
            </li>

          </ul>
        </td>
        <!--<td class="text-center">-->
        <!--<button class="btn btn-xs" style="padding: 5px; padding-left: 10px; padding-right: 10px; background-color: #38B2F7;" title="More detail">-->
        <!--<a style="color: #fff;" [routerLink]="['/industry']" [queryParams]="{industry_id: industry.id}"><i class="icon-more2"></i></a>-->
        <!--</button>-->
        <!--</td>-->
      </tr>
      </tbody>

      <tbody *ngIf="!industryListLoader && !allIndustriesDetails.length" >
      <tr>
        <td colspan="12" class="col-lg-12 text-center" style="height: 180px;">
          <div class="label label-danger" style="margin-top: 50px;">No Industry Found</div>
        </td>
      </tr>
      </tbody>

      <tbody *ngIf="industryListLoader" >
      <tr>
        <td colspan="12" class="col-lg-12 text-center" style="height: 180px;">
          <div style="margin-top: 50px;">
            <img src="/assets/images/load.gif" />
          </div>
        </td>
      </tr>
      </tbody>

    </table>
  </div>

</div>
